
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  margin-right: 0.5rem;
  display: inline-block;
  cursor: pointer;
  border-radius: 0.5rem
}

div.wrapper {
  display: inline-block;
  border-radius: 0.5rem;
  background-color: var(--neutral-white);
  padding: 0.5rem;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  border:2px solid var(--blue-responsible-main);
}

div.wrapper:hover {
  background-color: var(--blue-responsible-main)
}

div.wrapper:hover outline-icon {
  color: var(--outline-white)
}

outline-link {
  height: 100%;
  width: 100%
}

div.social-icon--footer {
  border-width: 0px;
  background-color: var(--neutral-transparent);
  padding: 0px;
}

div.social-icon--footer outline-icon {
  height: 1.5rem
}

div.social-icon--footer outline-icon {
  color: var(--outline-white)
}

div.social-icon--footer:hover {
  background-color: var(--neutral-transparent)
}

div.social-icon--footer:hover {
  opacity: 0.8
}
`;